<!--  -->
<template>
  <div class="card_wrap" style="">
    <div class="header_wrap">
      <p class="header_p">
        增值服务报价设置<el-divider direction="vertical"></el-divider>
      </p>
      <el-form
  
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
      >
        <el-form-item label="国家">
          <el-select clearable  v-model="formInline.countryId">
            <el-option
              v-for="item in countAll"
              :key="item.id"
              :label="item.namec"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="计费等级">
          <el-select clearable  v-model="formInline.vipId">
            <el-option
              v-for="item in VIPList"
              :key="item.vipId"
              :label="item.vipcode"
              :value="item.vipId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select clearable  v-model="formInline.status">
            <el-option
              v-for="item in statusLIst"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getShowcount()">查询</el-button>
        </el-form-item>
      </el-form>
      <el-button type="success"  @click="addFrom()">新增</el-button>
    </div>
    <div class="Center_wrap">
      <template>
        <el-table
          size="mini"
          max-height="700px"
          tooltip-effect="dark"
          :header-cell-style="{ background: '#F3F3F3' }"
          ref="multipleTable"
          border
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column type="index" align="center" label="序号" width="50">
          </el-table-column>
          <el-table-column align="center" prop="country" label="国家" width="180">
          </el-table-column>
          <el-table-column align="center" prop="busType" label="业务类型">
          </el-table-column>
          <el-table-column align="center" prop="vipcode" label="客户等级">
          </el-table-column>
          <el-table-column align="center" prop="beginTime" label="生效日期">
          </el-table-column>
          <el-table-column align="center" prop="endTime" label="失效日期">
          </el-table-column>
          <el-table-column align="center" prop="status" label="状态">
            <template slot-scope="scope">
              <span>{{scope.row.status==1?'草稿':scope.row.status==2?'提交':scope.row.status==3?'审核通过':scope.row.status==4?'审核不通过':scope.row.status==5?'作废':''}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="submitter" label="提交人">
          </el-table-column>
          <el-table-column align="center" prop="submitTime" label="提交时间">
          </el-table-column>
          <el-table-column align="center" prop="reviewer" label="审核人">
          </el-table-column>
          <el-table-column align="center" prop="reviewTime" label="审核时间">
          </el-table-column>
          <el-table-column align="center" prop="reviewReason" label="审核原因">
          </el-table-column>
          <el-table-column label="操作" align="center" width="300">
            <template slot-scope="scope">
              <el-button slot="reference"  size="mini" @click="setItem(scope.row)">查看</el-button>
              <el-button
                v-if="scope.row.status==1||scope.row.status==4"
                size="mini"
                type="warning"
                @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button v-if="scope.row.status==1" slot="reference" @click="tableDelete(scope.row)" type="danger"  size="mini">删除</el-button>
              <el-button
                v-if="scope.row.status==1||scope.row.status==4"
                size="mini"
                type="success"
                @click="Qdsubim(scope.row)"
                >提交</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
    <div class="TB_center" style="width: 100%; margin-top: 50px">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" layout="prev, pager, next" :total="countlisttotal"></el-pagination>
    </div>
    <!-- 新增 -->
    <el-dialog
      width="1250px"
      center
      title="增值服务报价"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        label-position="left"
        :inline="true"
        :model="ruleform"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label-width='100px'
              :rules="[{ required: true, message: '不能为空' }]"
              label="国家"
            >
              <el-select
                style="width:400px"
                v-model="ruleform.countryId"
                @change="changeCoutry(ruleform.countryId)">
                <el-option
                  v-for="item in countAll"
                  :key="item.id"
                  :label="item.namec"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
            label-width='100px'
              :rules="[{ required: true, message: '不能为空' }]" label="业务类型">
              <el-select
                style="width:400px"
                v-model="ruleform.busType">
                <el-option
                  v-for="item in busAlllist"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label-width='100px'
              :rules="[{ required: true, message: '不能为空' }]"
              label="客户等级"
            >
              <el-select
                style="width:400px"
                v-model="ruleform.vipId">
                <el-option
                  v-for="item in VIPList"
                  :key="item.vipId"
                  :label="item.vipcode"
                  :value="item.vipId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item  :rules="[{ required: true, message: '不能为空' }]" label="有效时间" label-width="100px">
            <div class="block">
              <el-date-picker
              style="width:400px"
                 v-model="hiveTime"
                 @change="changeTime(hiveTime)"
                 format='yyyy-MM-dd HH:mm:ss'
                 value-format='yyyy-MM-dd HH:mm:ss'
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </div>
          </el-form-item>
          
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" label-width="100px">
            <el-input
              style="width:1010px"
              v-model="ruleform.remarks"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          </el-col>
        </el-row>
      
      </el-form>
      <div style="width:100%;float:left;padding-bottom:10px" v-if="ruleform.countryId">
        <el-button  icon="el-icon-circle-plus-outline" @click="addFromitem()" style="float:left;background: #5F4AFF;color:#ffffff">新增</el-button>
      </div>
      <div v-if="ruleform.countryId" style="width: 100%;float: left;display: flex;justify-content: center;margin-bottom: 30px;">
          <div class="boxwrap" style="width:100%;float:left;padding:0px;margin-bottom:15px" >
            <el-form label-position="left" class="demo-dynamic" size="mini" :model="ruleform" ref="ruleform">
                <el-card class="Boxcard" v-for="(item, index) in ruleform.detailList" :key="index">
                    <div  style="background:#F2F6FC;border-radius: 8px;padding: 6px">
                        <el-row :gutter="0" style="margin:0">
                            <el-col :span="3">
                                <div class="grid-content">
                                    <div class="boxtableLabel"> <span style="color:red">*</span> 增值服务</div>
                                    <el-form-item class="boxTetx" :prop="'detailList.' + index + '.feeitemid'" :rules="moreNotOjb.Notfeeitemid">
                                        <el-select v-model="item.feeitemid" placeholder="请选择" @change="changeUnit(index,item.feeitemid)">
                                          <el-option
                                            v-for="res in fillList"
                                            :key="res.feeitemid"
                                            :label="res.feeitemName"
                                            :value="res.feeitemid">
                                          </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="2">
                                <div class="grid-content">
                                    <div class="boxtableLabel">  <span style="color:red">*</span>计费类型</div>
                                    <el-form-item class="boxTetx" :rules="moreNotOjb.priceType" :prop="'detailList.' + index + '.priceType'">
                                        <el-select v-model="item.priceType" placeholder="请选择">
                                          <el-option
                                            v-for="item in priceTypeLits"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                          </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="2">
                                <div class="grid-content">
                                    <div class="boxtableLabel"> <span style="color:red">*</span>计费单位</div>
                                    <el-form-item class="boxTetx" :prop="'detailList.' + index + '.priceUnit'">
                                        <el-input disabled v-model="item.priceUnit"></el-input>
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="2">
                                <div class="grid-content">
                                    <div class="boxtableLabel"> <span style="color:red">*</span>币种</div>
                                    <el-form-item class="boxTetx" :prop="'detailList.' + index + '.currency'" :rules="moreNotOjb.Notcurrency">
                                        <el-select v-model="item.currency" placeholder="请选择">
                                          <el-option
                                            v-for="item in currencyList"
                                            :key="item.name"
                                            :label="item.name"
                                            :value="item.name">
                                          </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="2">
                                <div class="grid-content">
                                    <div class="boxtableLabel"> <span style="color:red">*</span> 单价</div>
                                    <el-form-item class="boxTetx" :prop="'detailList.' + index + '.price'" :rules="moreNotOjb.Notprice">
                                        <el-input v-model="item.price" ></el-input>
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="3">
                                <div class="grid-content">
                                    <div class="boxtableLabel">开始数量</div>
                                    <el-form-item class="boxTetx" :prop="'detailList.' + index + '.pieceStart'" :rules="moreNotOjb.NotpieceStart">
                                        <el-input v-model="item.pieceStart" ></el-input>
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="3">
                                <div class="grid-content">
                                    <div class="boxtableLabel">结束数量</div>
                                    <el-form-item class="boxTetx" :prop="'detailList.' + index + '.pieceEnd'" :rules="moreNotOjb.NotpieceEnd">
                                        <el-input v-model="item.pieceEnd"></el-input>
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="3">
                                <div class="grid-content">
                                    <div class="boxtableLabel">最低收费</div>
                                    <el-form-item class="boxTetx" :prop="'detailList.' + index + '.minCharge'" :rules="moreNotOjb.NotminCharge">
                                        <el-input v-model="item.minCharge" ></el-input>
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="3">
                                <div class="grid-content">
                                    <div class="boxtableLabel">最高收费</div>
                                    <el-form-item class="boxTetx" :prop="'detailList.' + index + '.maxCharge'" :rules="moreNotOjb.NotmaxCharge">
                                        <el-input v-model="item.maxCharge"></el-input>
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="1">
                                <div class="grid-content">
                                    <div class="boxtableLabel">操作</div>
                                    <el-button :disabled="ruleform.detailList.length<=1" type="text" size="small" style="color:red" @click="handleDelete(index)">删除</el-button>
                                </div>
                            </el-col>
                        </el-row>
                        
                    </div>
                </el-card>
            </el-form>
        </div>
        
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="setQd()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查看 -->
    <el-dialog
      width="1150px"
      center
      title="查看增值服务报价"
      :visible.sync="setDatatype"
    >
     <el-row :gutter="20">
      <div style="margin-bottom:25px;width:100%;float:left">
          <el-col :span="8">
          <span class="settit">国家</span>
          <span class="setTest">{{setCount.countryName}}</span>
          </el-col>
          <el-col :span="8">
            <span class="settit">业务类型</span>
            <span class="setTest">{{setCount.busType}}</span>
          </el-col>
          <el-col :span="8">
            <span class="settit">客户等级</span>
            <span class="setTest">{{setCount.vipcode}}</span>
          </el-col>
      </div>
      <el-col :span="12">
        <span class="settit">有效时间</span>
        <span class="setTest">{{setCount.beginTime}}--{{setCount.endTime}}</span>
      </el-col>
      <el-col :span="12">
        <span class="settit">备注</span>
        <span class="setTest">{{setCount.remarks}}</span>
      </el-col>
    </el-row>
    <div style="margin-top:40px">
      <el-table
      :data="setCount.detailList"
      style="width: 100%">
      <el-table-column
        prop="feeitemName"
        label="增值服务"
        width="180">
      </el-table-column>
      <el-table-column
        prop="priceType"
        label="计费类型"
        width="180">
        <template slot-scope="scope">
        {{scope.row==1?'一口价':'阶梯价'}}
      </template>
      </el-table-column>
      <el-table-column
        prop="priceUnit"
        label="计费单位">
      </el-table-column>
      <el-table-column
        prop="currency"
        label="币种">
      </el-table-column>
      <el-table-column
        prop="price"
        label="单价">
      </el-table-column>
      <el-table-column
        prop="pieceStart"
        label="开始数量">
      </el-table-column>
      <el-table-column
        prop="pieceEnd"
        label="结束数量">
      </el-table-column>
      <el-table-column
        prop="minCharge"
        label="最低收费">
      </el-table-column>
      <el-table-column
        prop="maxCharge"
        label="最高收费">
      </el-table-column>
    </el-table>
    </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="setDatatype = false">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import qs from "qs";
export default {
  components: {},
  data() {
    return {
      setCount:{},//查询数据
      setDatatype:false,
      fillList:[],//增值服务
      currencyList:[],
      busAlllist:[
        {name:'FBA',id:0},
      ],
      statusLIst:[
        {name:'全部',id:0},
        {name:'草稿',id:1},
        {name:'已提交',id:2},
        {name:'审核通过',id:3},
        {name:'审核不通过',id:4},
        {name:'作废',id:5},
      ],

      priceTypeLits:[
        {name:'一口价',id:'1'},
        {name:'阶梯价',id:'2'},
      ],
       moreNotOjb: {
         NotcountryId: [{ required: false, message: "国家不能为空" }],
          Notfeeitemid: [{ required: false, message: "增值服务不能为空" }],
          priceType:[{ required: true, message: "计费类型不能为空" },],
          Notcurrency:[{ required: true, message: "币种不能为空" },],
          Notprice: [
            { required: true, message: "单价不能为空" },
            {
              validator: (rule, value, callback) => {
                if (value.length > 15 || value.length < 1) {
                  callback(new Error("只能为1-15个字符"));
                } else {
                  var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
                  if (!reg.test(value)) {
                    callback(new Error("只能大于零且保留最多两位小数"));
                  } else {
                    callback();
                  }
                }
              },
              trigger: "change",
            },
          ],
        NotpieceStart: [
          {
            validator: (rule, value, callback) => {
              if(value){
                if (value.length > 15 || value.length < 1) {
                callback(new Error("只能为1-15个字符"));
              } else {
                var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
                if (!reg.test(value)) {
                  callback(new Error("只能大于零"));
                } else {
                  callback();
                }
              }
              }else{
                callback();
              }
            },
            trigger: "change",
          },
        ],
        NotpieceEnd:[
          {
            validator: (rule, value, callback) => {
              if(value){
                if (value.length > 15 || value.length < 1) {
                callback(new Error("只能为1-15个字符"));
              } else {
                var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
                if (!reg.test(value)) {
                  callback(new Error("只能大于零"));
                } else {
                  callback();
                }
              }
              }else{
                callback();
              }
              
            },
            trigger: "change",
          },
        ],
        NotminCharge: [
          {
            validator: (rule, value, callback) => {
              if(value){
                if (value.length > 15 || value.length < 1) {
                callback(new Error("长度只能为1-15个字符"));
              } else {
                var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
                if (!reg.test(value)) {
                  callback(new Error("只能大于零且保留最多两位小数"));
                } else {
                  callback();
                }
              }
              }else{
                callback();
              }
              
            },
            trigger: "change",
          },
        ],
        NotmaxCharge:[
          {
            validator: (rule, value, callback) => {
              if(value){
                if (value.length > 15 || value.length < 1) {
                callback(new Error("只能为1-15个字符"));
              } else {
                var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
                if (!reg.test(value)) {
                  callback(new Error("只能大于零且保留最多两位小数"));
                } else {
                  callback();
                }
              }
              }else{
                callback();
              }
              
            },
            trigger: "change",
          },
        ],
      },
      hiveTime:[],//开始结束日期数组
      ruleform: {
            beginTime:'',
            busType:'',
            countryId:'',
            endTime:'',
            id:'',
            remarks:'',
            vipId:'',
            detailList: [
            {
                currency: "", 
                feeitemid:'',
                id:'',
                maxCharge:'',
                minCharge:'',
                pieceStart:'',
                pieceEnd:'',
                price:'',
                priceType:'',
                priceUnit:''
            },
            ],
        },
      pageNum:1,
      countlisttotal:0,
      countAll: [],
      VIPList: [],
      checkedCitylist: [],
      filterMethod(query, item) {
        return item.namec.indexOf(query) > -1;
      },
      dialogTableVisible: false,
      dialogFormVisible: false,
      formInline: {
        status: "",
        countryId: "",
        vipId:''
      },
      tableData: [],
    };
  },
  computed: {},
  watch: {},
  methods: {
    tableDelete(item){ //删除
    console.log(item)
    let that = this
        this.$confirm('确定删除该数据吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
              that.axios
                .get(`/carrier/quoteProductAdd/deleteCarrierQuoteProductAdd/${item.id}`)
                .then((res) => {
                  that.getShowcount()
                })
                .catch(function (error) {
                  console.log(error);
                });
        }).catch(() => {
          that.$message({
            type: 'info',
            message: '已取消'
          });          
        });
    


    },
    setItem(item){ //查看
        this.axios
        .get(`/carrier/quoteProductAdd/getCarrierQuoteProductAddInfo/${item.id}`)
        .then((res) => {
          console.log(res.data)
          this.setDatatype = true
          this.setCount = res.data.data
         
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    Qdsubim(item){ //提交
        let that = this
        this.$confirm('提交该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.axios
            .get(`/carrier/quoteProductAdd/submitCarrierQuoteProductAdd/${item.id}`)
            .then((res) => {
              console.log(res)
                if(res.data.code==-1){
                    that.$message({type: "info",message:res.data.message})
                }else{
                  that.pageNum = 1
                  that.getShowcount()
                  that.$message({type: "success",message:'成功'})
                }
                  
            })
            .catch(function (error) {
              console.log(error);
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });          
        });
        
    },
    setQd() {
      if(!this.ruleform.countryId) return this.$message({type: "info",message: "请选择国家"});
      if(!this.ruleform.busType) return this.$message({type: "info",message: "请选择业务类型"});
      if(!this.ruleform.vipId) return this.$message({type: "info",message: "请选择客户等级"});
      if(!this.ruleform.beginTime) return this.$message({type: "info",message: "请选择有效时间"});
      this.$refs['ruleform'].validate((valid) => {
          if (valid) {
            let File = true;
            try{
              this.ruleform.detailList.forEach((item,index)=>{
                  if(+item.pieceStart>+item.pieceEnd){File = false; throw this.$message({type: "info",message: `第${index+1}行结束数量不能小于开始数量`});}
                  if(+item.minCharge>+item.maxCharge){File = false;throw this.$message({type: "info",message: `第${index+1}行最低收费不能小于最高收费`});}
              })
            }catch (err) {
              File = false;
            }
            if(File){
              this.POstdata()
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    POstdata(){
      let params = this.ruleform
      this.axios
        .post("/carrier/quoteProductAdd/insertOrUpdateCarrierQuoteProductAdd", params)  
        .then((res) => {
          console.log(res);
          if(res.data.code==-1){
               this.$message({type: "info",message:res.data.message})
            }else{
              this.dialogFormVisible = false
              this.pageNum = 1
              this.getShowcount()
              this.$message({type: "success",message:'成功'})
            }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    changeTime(item){
      this.ruleform.beginTime = item[0]
      this.ruleform.endTime = item[1]
    },
    addFromitem(){
      let obj = {
                currency: "", 
                feeitemid:'',
                id:'',
                maxCharge:'',
                minCharge:'',
                pieceStart:'',
                pieceEnd:'',
                price:'',
                priceType:'',
                priceUnit:''
            }
      this.ruleform.detailList.push(obj)   
    },
    changeUnit(index,itemID){
       this.fillList.find(item=>{
         if(item.feeitemid==itemID){
           this.ruleform.detailList[index].priceUnit = item.priceUnit
         }
      })
      console.log(this.ruleform.detailList)
    },
    changeCoutry(){

      this.ruleform.detailList = [
            {
                currency: "", 
                feeitemid:'',
                id:'',
                maxCharge:'',
                minCharge:'',
                pieceStart:'',
                pieceEnd:'',
                price:'',
                priceType:'',
                priceUnit:''
            }
          ]

    },
    getByCountry(id){ //获取增值服务
      this.axios
        .get(`/filedata/findCarrierInternationalFeeitemList`)
        .then((res) => {
          this.fillList = res.data.datas
          
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getcurrencydata(){ //获取所有币种
      this.axios
        .get(`/filedata/findCurrencyAll`)
        .then((res) => {
          
          res.data.datas.forEach(item=>{
            let obj = {
              name:item
            }
            this.currencyList.push(obj)
          })
          console.log(this.currencyList)
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleDelete(index,item){
      this.$confirm("确定删除该信息吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.ruleform.detailList.splice(index, 1);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleEdit(index,item){ //修改前查看
      console.log(item)
      this.axios
        .get(`/carrier/quoteProductAdd/getCarrierQuoteProductAddInfo/${item.id}`)
        .then((res) => {
          console.log(res.data)
          this.ruleform.beginTime =res.data.data.beginTime
          this.ruleform.busType =res.data.data.busType
          this.ruleform.countryId =res.data.data.countryId
          this.ruleform.endTime =res.data.data.endTime
          this.ruleform.id =res.data.data.id
          this.ruleform.remarks =res.data.data.remarks
          this.ruleform.vipId =res.data.data.vipId
          this.ruleform.detailList =res.data.data.detailList
          this.hiveTime[0] = res.data.data.beginTime
          this.hiveTime[1] = res.data.data.endTime
          this.getByCountry(res.data.data.countryId)
          this.dialogFormVisible = true
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getVIPAll() {
      this.axios
        .post(`/filedata/findFbaVipInfoAll`)
        .then((res) => {
          console.log(res.data)
          this.VIPList = res.data.datas;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    
    geicountAll() {
      //获取所有国家
      this.axios
        .get("/filedata/findCountryAll")
        .then((res) => {
          this.countAll = res.data.datas;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.pageNum = val
        this.getShowcount()
      },
    getShowcount() {//查询列表数据
      let params = {
        countryId: "",
        pageNum:this.pageNum,
        pageSize:20,
        status:this.formInline.status==0?'':this.formInline.status,
        vipId:this.formInline.vipId,
        countryId:this.formInline.countryId
      };
      this.axios
        .post("/carrier/quoteProductAdd/getQuoteProductAddList", params)
        .then((res) => {
          console.log(res)
          this.tableData = res.data.data.list
          this.countlisttotal = res.data.data.total
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    addFrom() { //初始化数据
      this.dialogFormVisible = true;
      this.ruleform.beginTime = ''
      this.ruleform.busType = ''
      this.ruleform.countryId = ''
      this.ruleform.endTime = ''
      this.ruleform.id = ''
      this.ruleform.remarks = ''
      this.ruleform.vipId = ''
      this.ruleform.detailList = [
            {
                currency: "", 
                feeitemid:'',
                id:'',
                maxCharge:'',
                minCharge:'',
                pieceStart:'',
                pieceEnd:'',
                price:'',
                priceType:'',
                priceUnit:''
            },
            ]
      this.hiveTime = []
    },
  },

  created() {},
  mounted() {
    this.getVIPAll()
    this.geicountAll();
    this.getShowcount()
    this.getcurrencydata()
    this.getByCountry()
  },
};
</script>
<style  scoped>
.Boxcard{
    margin-bottom: 15px;
    border-radius: 15px;
}
.grid-content {
  min-height: 36px;
  text-align: center;
  height:46px;
}
.boxwrap >>> .el-card__body {
  padding:10px !important;
}
.setTest{
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  margin-left:30px
}
.settit{
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #999999;
}
.TB_center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.card_wrap {
  padding: 30px;
  background: rgb(255, 255, 255);
  box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;
  border-radius: 10px;
}
.header_p {
  font-size: 30px;
  font-weight: bold;
  padding-bottom: 35px;
}
.Center_wrap {
  margin-top: 35px;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>


// WEBPACK FOOTER //
// src/components/QuotationManagement/Addedservice.vue